export const COLORS = Object.freeze({
  red: 'var(--tonal-r-50)',
  orange: 'var(--tonal-y-40)',
  yellow: 'var(--tonal-y-60)',
  green: 'var(--tonal-g-50)',
  blue: 'var(--tonal-a-55)',
  purple: 'purple',
  grey: 'grey',
})
